import { useQuizHistory } from "./useQuizHistory"

export const useQuestionIdFromUrl = () => {
  const {
    params: { question },
  } = useQuizHistory()

  return question
}
